import React, { useState } from 'react';
import { Menu, Icon, Input } from 'semantic-ui-react';
import CardMCSummaryHighTrafficUse from './CardMCSummaryHighTrafficUse';
import CardMCSummaryHighAppointment from './CardMCSummaryHighAppointment';
import CardMC2Panel from './CardMC2Panel';

type CardMCUtilizationOperationsProps = {
  // Add props if needed
  controller: any,
  runSequence: any,
  MeChartSequence: any,
}

const CardMCUtilizationOperations = (props: CardMCUtilizationOperationsProps) => {
  const [activeItem, setActiveItem] = useState('high_traffic');
  const [searchQuery, setSearchQuery] = useState('');

  const menuItems = [
    { name: 'high_traffic', label: 'สรุปช่วงเวลาหนาแน่นการรับบริการ (ปี ค.ศ.)' },
    { name: 'high_appointment', label: 'สรุปช่วงเวลาหนาแน่นในการนัดหมายของผู้รับบริการ (ปี ค.ศ.)' },
  ];

  const handleItemClick = (e: any, { name }: any) => setActiveItem(name);

  const filteredMenuItems = menuItems.filter(item =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // The renderContent function is simplified or removed based on the new structure
  // The content is now directly rendered in the rightPanel prop of CardMC2Panel
  // The original instruction snippet for renderContent was malformed,
  // so I'm interpreting the intent to move the rendering logic directly to the CardMC2Panel's rightPanel.

  const leftPanelContent = (
    <>
      <div className="search-container">
        <Input
          icon='search'
          placeholder='Search reports...'
          fluid
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <Menu fluid vertical tabular className="nav-menu">
        {filteredMenuItems.map((item) => (
          <Menu.Item
            key={item.name}
            name={item.name}
            active={activeItem === item.name}
            onClick={handleItemClick}

          >
            <div className="item-content">
              <span>{item.label}</span>
              {activeItem === item.name && <Icon name='chevron right' className="icon" />}
            </div>
          </Menu.Item>
        ))}
      </Menu>
    </>
  );

  return (
    <div id="card-mc-utilization-operations">
      <CardMC2Panel
        leftPanel={
          <div className="left-panel-container">
            {leftPanelContent}
          </div>
        }
        rightPanel={
          <div className="right-panel-container">
            {activeItem === 'high_traffic' && <CardMCSummaryHighTrafficUse controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
            {activeItem === 'high_appointment' && <CardMCSummaryHighAppointment controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence} />}
            {activeItem !== 'high_traffic' && activeItem !== 'high_appointment' && <div>Select a report</div>}
          </div>
        }
      />
    </div>
  );
};

export default CardMCUtilizationOperations;
